import Orders from "@/pages/Orders/Orders.vue";
import DetailOrder from "@/components/Order/DetailOrder.vue";

import { createBreadCrumbs, setNavigator } from "@/router/routerFunction";


export function routesOrders() {
  return [
    {
      path: "/soluzioni-richieste",
      name: "Ordersit",
      component: Orders,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "orders",
            url: "",
          },
        ],
        indexRoute: "soluzioni-richieste",
        permissions: [
          "ordini",
          "verifica_copertura"
        ],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/solutions-requested",
      name: "Ordersen",
      component: Orders,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "orders",
            url: "",
          },
        ],
        indexRoute: "solutions-requested",
        permissions: [
          "ordini",
          "verifica_copertura"
        ],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/soluzione-dettaglio/:order_id/",
      name: "OrderDetailsit",
      component: DetailOrder,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "orders",
            url: "/soluzioni-richieste",
          },
          {
            name: "summaryOrderLine",
            url: "",
          },
        ],
        indexRoute: "soluzioni-richieste",
        permissions: [
          "ordini",
          "verifica_copertura"
        ],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/solutions-detail/:order_id",
      name: "OrderDetailsen",
      component: DetailOrder,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "orders",
            url: "/solutions-requested",
          },
          {
            name: "summaryOrderLine",
            url: "",
          },
        ],
        indexRoute: "solutions-detail",
        permissions: [
          "ordini",
          "verifica_copertura"
        ],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
  ]
}